import { getField, updateField } from 'vuex-map-fields'
import apiAxios from '../../services/apiAxios'
import moment from 'moment'
import helpers from '../../mixins/helpers'

const state = {
  ventas: [],
  /* Paginacion */
  paginaActual: 1,
  registrosPorPagina: 10,
  totalRegistros: 0,
  totalPaginas: 0,

  /* Filtro */
  filtroPeriodo: true,
  filtroNumero: false,

  fechaDesde: moment(new Date()).add(-30, 'days').format('YYYY-MM-DD'),
  fechaHasta: moment(new Date()).format('YYYY-MM-DD'),
  cliente: null,

  numero: 0,
  numeroPuntoVenta: 0,
  comprobanteTipo: null,

  sortByDescending: true,
}

const mutations = {
  updateField,

  INICIALIZAR_OPCIONES(state) {
    state.ventas = []
    /* Paginacion */
    state.paginaActual = 1
    state.registrosPorPagina = 10
    state.totalRegistros = 0
    state.totalPaginas = 0

    /* Filtro */
    state.filtroPeriodo = true
    state.filtroNumero = false

    state.fechaDesde = moment(new Date()).add(-30, 'days').format('YYYY-MM-DD')
    state.fechaHasta = moment(new Date()).format('YYYY-MM-DD')
    state.cliente = null

    state.numero = 0
    state.numeroPuntoVenta = 0
    state.comprobanteTipo = null

    state.sortByDescending = true
  },

  INICIALIZAR_VENTAS(state) {
    state.ventas = []
    // state.ventasSeleccionadas = [];
  },
  SET_VENTAS(state, ventas) {
    state.ventas = ventas;
  },
  SET_PAGINATION(state, params) {
    state.paginaActual = params.paginaActual
    state.registrosPorPagina = params.registrosPorPagina
    state.totalRegistros = params.totalRegistros
    state.totalPaginas = params.totalPaginas
  }
}

const getters = {
  getField,
}

const actions = {
  inicializarOpciones({ commit }) {
    commit('INICIALIZAR_OPCIONES')
  },

  getVentasNegociaciones({ commit }) {
    return new Promise((resolve, reject) => {
      commit('INICIALIZAR_VENTAS')

      let queryString = '?pageSize=' + state.registrosPorPagina 
        + '&pageNumber=' + state.paginaActual 
        + '&sortByDescending=' + state.sortByDescending

      if (/true/i.test(state.filtroNumero)) {
        queryString += '&numero=' + state.numero

        if (state.numeroPuntoVenta != 0) {
          queryString += '&numeroPuntoVenta=' + state.numeroPuntoVenta
        }

        if (state.comprobanteTipo) {
          if (state.comprobanteTipo.id != 0) {
            queryString += '&comprobanteTipoId=' + state.comprobanteTipo.id
          }
        }
      }

      if (/true/i.test(state.filtroPeriodo)) {
        queryString += '&fechaDesde=' + moment(state.fechaDesde).format('YYYY-MM-DD') 
          + '&fechaHasta=' + moment(state.fechaHasta).format('YYYY-MM-DD')

        if (state.cliente) {
          if (state.cliente.id != 0) {
            queryString += '&clienteId=' + state.cliente.id
          }
        }
      }

      apiAxios.get('ventas/negociadas' + queryString)
        .then((res) => {
          if (res.headers.pagination) {
            const pagination = JSON.parse(res.headers.pagination)
            var params = {
              paginaActual: pagination.currentPage,
              registrosPorPagina: pagination.itemsPerPage,
              totalRegistros: pagination.totalItems,
              totalPaginas: pagination.totalPages,
            }
            commit('SET_PAGINATION', params)
          }
          commit('SET_VENTAS', res.data)

          resolve()
        })
        .catch((error) => reject(helpers.methods.getErrorMessage(error)))
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
